import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=52ebfcc4&"
import script from "./UserInformation.vue?vue&type=script&lang=js&"
export * from "./UserInformation.vue?vue&type=script&lang=js&"
import style0 from "./UserInformation.vue?vue&type=style&index=0&id=52ebfcc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports